import React, { useState, useRef, useEffect } from "react";
import "../Forms/OtpVerify.css";
const OtpVerify = ({onClose,settingsData,varifyOTPFun,otpHandler}) => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = useRef([]); 

 
  const handleInputChange = (e, index) => {
    const value = e.target.value;
    if (/^\d+$/.test(value) && index >= 0 && index < 4) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (index < 3) {
        inputRefs.current[index + 1].focus(); 
      }
    }
  };


const handleBackspace = (e, index) => {
    if (e.keyCode === 8) {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
  
      if (index > 0) {
        inputRefs.current[index - 1].focus(); 
      }
    }
  };

  useEffect(() => {
    inputRefs.current[0].focus();
  }, []);

  useEffect(() => {
    if (settingsData.mobile_status) {
      const timeoutId = setTimeout(() => {
        onClose();
      }, 1000);
      return () => clearTimeout(timeoutId);
    }

  }, [settingsData, onClose]);


  const otpvalidate=()=>{     
    varifyOTPFun(otp);
  }

  const resendOtp=()=>{     
    otpHandler();
  }
  

  return (
    <>
      <div className="df aic jcc fdc">
        <p className="fw6 fc14 fs18 ls1 lh22">Please enter the One-Time Password to verify</p>
        <p className="ls1 fc16 fs14 mt8 lh22">A One-Time Password has been sent to {settingsData.mobile_number}</p>
      </div>
      <div className="otp-form df aic jcc mt24">
        {otp.map((value, index) => (
          <input
            key={index}
            type="text"
            className="otp-input"
            value={value}
            maxLength="1"
            onChange={(e) => handleInputChange(e, index)}
            onKeyDown={(e) => handleBackspace(e, index)}
            ref={(input) => (inputRefs.current[index] = input)}
          />
        ))}
        
      </div>

      <p className="fs14 ls1 lh14 mb24 fc3 box-center mt8 cp tdu" onClick={resendOtp}>
            Resend OTP
        </p>

      {!settingsData.mobile_status && (
        <div className="form-error-messages error mt8 blink-text-normal-error tac">
          {settingsData.otp_msg}
        </div>
      )}

      {settingsData.mobile_status && (
        <div className="form-error-messages error mt8 blink-text-normal-success tac">
          {settingsData.otp_msg}
        </div>
      )}
      
      
      

      <div className="box-center mt32 mb32">
      <button type="button" 
      className=" pl16 pr16 pt8 pb8 bg3 fc1 br24 ls2 cp v-center fs16 "
      onClick={otpvalidate}
      >
          Validate
        </button>
        
      </div>
      <div className="button-container brd-t2 pt16 df jce">
        <button type="button" className="btn-cancel" onClick={onClose}>
          Cancel
        </button>
      </div>
    </>
  );
};

export default OtpVerify;
